import { wrapReducers } from 'redaction'
import localReducers from 'redux/reducers'
import wrapRouterReducers from 'redux/router/reducer'


// add new reducers here
export default (dispatchResolver) => ({
  ...wrapReducers(localReducers),
  // news: wrapReducers(localReducers.news, 'news'),
  voting: wrapReducers(localReducers.voting, 'voting'),
  marketplace: wrapReducers(localReducers.marketplace, 'marketplace'),
  lscSchedules: wrapReducers(localReducers.lscSchedules, 'lscSchedules'),
  lscTransportControl: wrapReducers(localReducers.lscTransportControl, 'lscTransportControl'),
  emergencyAlert: wrapReducers(localReducers.emergencyAlert, 'emergencyAlert'),
  router: wrapRouterReducers(dispatchResolver),
})
